import { Col, Row } from 'react-bootstrap'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { getProgressPercentage } from 'components/monitoring/utils'
import BasePopover from '../BasePopover'

interface ProgressPopoverProps {
  progress: {
    finish: number
    inProgress: number
    pending: number
  }
  id?: string
  className?: string
  component?: React.ElementType
  popoverContent?: React.ReactNode
}

interface Label {
  label: React.ReactNode
  value: React.ReactNode
}

const prefixStateList = 'monitoring.attributes.stateAdvanceList'

export const ProgressPopover: React.FC<ProgressPopoverProps> = ({
  progress,
  id = '',
  children,
  className,
  component: Component = 'div',
}) => {
  const t = useTranslationRankmi({ prefix: prefixStateList })
  const { finish, inProgress, pending } = getProgressPercentage([progress])

  const labels: Label[] = [
    { label: t('finish'), value: finish },
    { label: t('inProgress'), value: inProgress },
    { label: t('pending'), value: pending },
  ]

  return (
    <BasePopover
      id={id}
      className={className}
      component={Component}
      popoverContent={
        <Row>
          {labels.map(({ label, value }, i) => (
            <Col xs={12} key={i}>
              <Row>
                <Col xs={6}>{label} </Col>
                <Col xs={6}>{value}%</Col>
              </Row>
            </Col>
          ))}
        </Row>
      }
    >
      {children}
    </BasePopover>
  )
}

export default ProgressPopover
